const KEY = "shoptosa_price_alerts_v1";

function loadAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch {
    return {};
  }
}

function saveAll(all) {
  localStorage.setItem(KEY, JSON.stringify(all));
}

export function localAlerts() {
  return Object.values(loadAll()).sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")));
}

export function localAlertFor(listingId) {
  return loadAll()[String(listingId || "")] || null;
}

export function saveLocalAlert({ listing_id, target_price, currency, title, user_id }) {
  const all = loadAll();
  const existing = all[listing_id] || {};
  const row = {
    id: existing.id || `local:${listing_id}`,
    listing_id,
    target_price: Number(target_price),
    currency: (currency || "USD").toUpperCase(),
    title: title || existing.title || "",
    user_id: user_id || existing.user_id || "",
    status: "watching",
    created_at: existing.created_at || new Date().toISOString(),
    updated_at: new Date().toISOString(),
    triggered_at: null,
    triggered_price: null,
  };
  all[listing_id] = row;
  saveAll(all);
  return row;
}

export function cancelLocalAlert(listingId) {
  const all = loadAll();
  const row = all[String(listingId || "")];
  if (!row) return null;
  row.status = "cancelled";
  row.updated_at = new Date().toISOString();
  all[listingId] = row;
  saveAll(all);
  return row;
}

export function checkLocalAlert(listingId, price) {
  const all = loadAll();
  const row = all[String(listingId || "")];
  const live = Number(price);
  if (!row || row.status !== "watching" || !Number.isFinite(live)) return row || null;
  if (live < Number(row.target_price)) {
    row.status = "triggered";
    row.triggered_price = live;
    row.triggered_at = new Date().toISOString();
    row.updated_at = row.triggered_at;
    all[listingId] = row;
    saveAll(all);
  }
  return row;
}
